import classes from "./RuleCardSkeleton.module.css";

const RuleCardSkeleton = () => {
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 0 4px rgba(0,0,0,0.15)",
            padding: "20px",
            gap: "8px",
            maxWidth: "400px",
        }}>
            {/* Main row */}
            <div style={{ display: "flex", justifyContent: "space-between", gap: "8px" }}>
                {/* LEFT */}
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", flex: 1, minWidth: 0 }}>
                    <div className={classes["skeleton-bar"]} style={{ height: "17px", width: "60%" }} />
                    <div className={classes["skeleton-bar"]} style={{ height: "13px", width: "40%" }} />
                    <div className={classes["skeleton-bar"]} style={{ height: "14px", width: "80%" }} />
                    <div className={classes["skeleton-bar"]} style={{ height: "14px", width: "65%" }} />
                </div>
                {/* RIGHT */}
                <div style={{ display: "flex", flexDirection: "column", gap: "5px", alignItems: "flex-end" }}>
                    <div className={classes["skeleton-bar"]} style={{ height: "20px", width: "50px" }} />
                    <div className={classes["skeleton-bar"]} style={{ height: "20px", width: "40px" }} />
                </div>
            </div>
            {/* FOOTER */}
            <div className={classes["skeleton-bar"]} style={{ height: "10px", width: "45%" }} />
        </div>
    );
};

export default RuleCardSkeleton;
